import axios from '@/utils/api'

const state = {}

const getters = {}

const actions = {
  async getUsuariosPorSetor ({ commit }, caixa) {
    if (caixa && (caixa !== 'portariaHomologacao' && caixa !== 'publicacao')) {
      const caixaSelecionada = caixa === 'cof/gestaoVtn' ? 'GESTAO_VTN' : (caixa === 'gat/informacoesSolicitadas' || caixa === 'cof/informacoesSolicitadas' ? 'INFORMACAO_SOLICITADA' : caixa)
      this.usuariosDisponiveis = await axios({
        method: 'POST',
        url: `usuarios/analistas/setor/caixa/${caixaSelecionada}`
      })
      return this.usuariosDisponiveis
    }
  },
  async getUsuarios ({ commit }, idProcesso) {
    const response = await axios({
      method: 'get',
      url: `usuarios/analistas/setor/${idProcesso}`
    })
    return response
  },
  async trocarResponsavel ({ commit }, processo) {
    this.usuariosDisponiveis = await axios({
      method: 'post',
      url: 'processo/processo/trocaAnalista',
      data: processo
    })
  },
  async getConfiguracao ({ commit }) {
    const response = await axios({
      method: 'get',
      url: 'publico/site/config'
    })
    return response
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/dados.js